import { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import styled from 'styled-components';
import {
  showBriefProductDescription,
  hideBriefProductDescription
} from '../../reduck/listingPageCommonData.reduck';
import uiLocale from '../../translations/UILocale.js';
import { ProductDescArrow } from '../ProductBriefDescription/ProductBriefDescription';

const ProductDescToggle = styled.div`
  .product-desc & {
    padding: 0.8em 0;
    color: #4855a0;
    cursor: pointer;

    i {
      margin: -2px 6px 0 0;
      font-size: 18px;
      line-height: 1;
      vertical-align: middle;
      min-width: 5px;
    }
  }
`;

const ProductDescToggleClosed = styled(ProductDescToggle)`
  ${ProductDescArrow} {
    display: none;
  }

  .resultList {
    .product {
      .product-desc & {
        padding-bottom: 0;
      }
    }
  }
`;

const ProductDescToggleOpened = styled(ProductDescToggle)`
  ${ProductDescToggleOpened} ${ProductDescArrow} {
    display: block !important;
    left: 50%;
    margin-left: -20px;
    bottom: -45px;
    z-index: 0;
  }

  .sponsored ${ProductDescToggleOpened} ${ProductDescArrow} {
    bottom: -20px;
  }
`;

const ProductDescToggleTitle = styled.span`
  line-height: 1;
  vertical-align: middle;

  &:hover {
    text-decoration: underline;
  }
`;

const ProductDesc = styled.div`
  display: block;
  margin-left: 8px;

  @media ${({ theme }) => `${theme.breakpoints.mobile}`} {
    display: none !important;
  }
`;

class ProductBriefDescriptionSwitch extends PureComponent {
  componentWillUnmount() {
    this.props.hideBriefProductDescription();
  }

  onBriefDescriptionClick() {
    if (this.props.briefDescriptionProductID === this.props.productID) {
      this.props.hideBriefProductDescription(null);
    } else {
      this.props.showBriefProductDescription(this.props.productID);
    }
  }

  render() {
    return (
      <ProductDesc
        data-component={'product-desc'}
        onClick={() => {
          this.onBriefDescriptionClick();
        }}
        className={'product-desc'}
      >
        {this.props.briefDescriptionProductID !== this.props.productID ? (
          <ProductDescToggleClosed className={'product-desc-toggle-closed'}>
            <i className={'dcg-icon-caret-right'} />
            <ProductDescToggleTitle
              className={'product-desc-toggle-title'}
              data-text={'Brief product description'}
            >
              {uiLocale.getString('component.productlisting.briefProductDescLabel')}
            </ProductDescToggleTitle>
            {this.props.withArrow && <ProductDescArrow className={'product-desc-arrow'} />}
          </ProductDescToggleClosed>
        ) : (
          <ProductDescToggleOpened className={'product-desc-toggle-opened'}>
            <i className={'dcg-icon-caret-down'} />
            <ProductDescToggleTitle className={'product-desc-toggle-title'}>
              {uiLocale.getString('component.productlisting.closeLabel')}
            </ProductDescToggleTitle>
            {this.props.withArrow && <ProductDescArrow className={'product-desc-arrow'} />}
          </ProductDescToggleOpened>
        )}
      </ProductDesc>
    );
  }
}

ProductBriefDescriptionSwitch.propTypes = {
  briefDescriptionProductID: PropTypes.string,
  hideBriefProductDescription: PropTypes.func,
  productID: PropTypes.string.isRequired,
  showBriefProductDescription: PropTypes.func,
  withArrow: PropTypes.bool
};

ProductBriefDescriptionSwitch.defaultProps = {
  briefDescriptionProductID: null,
  hideBriefProductDescription: () => {},
  showBriefProductDescription: () => {},
  withArrow: false
};

const mapStateToProps = (state) => ({
  briefDescriptionProductID: state.listingPage.commonData.briefDescriptionProductID
});

const dispatchFunctions = {
  showBriefProductDescription,
  hideBriefProductDescription
};

export default connect(mapStateToProps, dispatchFunctions)(ProductBriefDescriptionSwitch);
